import axios from 'axios'


export interface createAirwallexIntentRequest {
  "method": "airwallex_payments_card",
  "cart_id":string,
  "return_url":string //createAirwallexIntentRequest
}

export const createAirwallexIntent = async (
  payload: createAirwallexIntentRequest): Promise<any> => {
  
  const responseData = await axios.post(
    '/canawan/airwallex/payments/create_intent',
    {
      ...payload,
    },
    {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
      },
      
    },
  )

  return responseData
}
export interface createAirwallexIntentRequest {
  "method": "airwallex_payments_card",
  "cart_id":string,
  "return_url":string //createAirwallexIntentRequest
}

export const createAirwallexIntentCustomer = async (
  payload: createAirwallexIntentRequest, token=''
): Promise<any> => {
  
  const responseData = await axios.post(
    '/canawan/airwallex/payments/create_intent',
    {
      ...payload,
    },
    {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${token}`
      },
    },
  )

  return responseData
}
export interface placeholderAirwallexRequest {
  "cartId": any,
  "paymentMethod": {
      "method": "airwallex_payments_card",
      "po_number": string,
      "additional_data": {
          "intent_id": string,
          "amount": number,
          "intent_status": string
      }
  },
  "email": string
}
export const placeholderAirwallex = async (
  payload: placeholderAirwallexRequest,
  ): Promise<any> => {
    const responseData = await axios.post(
      '/canawan/guest-carts/'+ payload.cartId+'/payment-information',
      {
        ...payload,
      },
      {
        baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
        headers: {
          'Content-Type': 'application/json',
        },
      },
      )
      
      return responseData
    }
    export interface PlaceholderCustomerAirwallexRequest {
      billingAddress: {
        "countryId": string,
        "region": string,
        "street": Array<string>,
        "company":string,
        "telephone": any,
        "postcode": any,
        "city": string,
        "firstname": string,
        "lastname": string,
        "saveInAddressBook"?: any
    },
      "paymentMethod": {
          "method": "airwallex_payments_card",
          "po_number": any,
          "additional_data": {
              "intent_id": string,
              "amount": number,
              "intent_status": string
          }
      },
      "email"?: string
    }
export const placeholderCustomerAirwallex = async (
  payload: PlaceholderCustomerAirwallexRequest,token?:any
): Promise<any> => {
  const responseData = await axios.post(
    '/canawan/carts/mine/payment-information',
    {
      ...payload,
    },
    {
      baseURL: `${process.env.NEXT_PUBLIC_URL}/rest/V1`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${token}`
      },
    },
  )

  return responseData
}